import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import Home from '@/views/Home.vue'
import store from '@/store/index'
import { SIMULATOR } from '@/views/Login.vue'

Vue.use(VueRouter)

const simulator = sessionStorage.getItem(SIMULATOR)

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    beforeEnter: (to, from, next) => {
      if (store.getters.isAuthenticated) {
        if (store.getters.requirePin && from.name !== 'ResetPin') {
          next({ name: 'PinEnter' })
        } else {
          next()
        }
      } else {
        next({ name: 'Login' })
      }
    },
    alias: [
      '/mojtelenor',
      '/mojtelenor/lite'
    ],
    children: [
      {
        path: 'page',
        name: 'LeftView',
        component: () => import(/* webpackChunkName: "left" */ '../views/LeftViewResolver.vue'),
        children: [
          {
            path: 'view',
            name: 'LeftCardView',
            component: () => import(/* webpackChunkName: "leftCard" */ '../views/ViewComponentResolver.vue')
          }
        ]
      },
      {
        path: 'view',
        name: 'CardView',
        component: () => import(/* webpackChunkName: "card" */ '../views/ViewComponentResolver.vue')
      }
    ]
  },
  {
    path: '/login',
    name: 'Login',
    beforeEnter: (to, from, next) => {
      const subdomain = window.location.host.split('.')[0]
      if (process.env.NODE_ENV === 'production' && subdomain !== 'www') {
        next({ name: 'Redirect' })
      }
      if (store.getters.isAuthenticated) {
        next({ name: 'Home' })
      } else {
        next()
      }
    },
    component: () => import(/* webpackChunkName: "login" */ '../views/Login.vue')
  },
  {
    path: '/redirect',
    name: 'Redirect',
    beforeEnter: () => {
      window.location.href = window.location.protocol + '//www.' + window.location.host + window.location.pathname
    }
  },
  {
    path: '/login/:tempToken',
    name: 'LoginToken',
    beforeEnter: (to, from, next) => {
      localStorage.clear()
      next()
    },
    component: () => import(/* webpackChunkName: "login" */ '../views/Login.vue')
  },
  {
    path: '/logout',
    name: 'Logout',
    beforeEnter: (to, from, next) => {
      if (store.getters.isAuthenticated) {
        next()
      } else {
        next({ name: 'Login' })
      }
    },
    component: () => import(/* webpackChunkName: "logout" */ '../views/Logout.vue')
  },
  {
    path: '/pin',
    name: 'PinEnter',
    beforeEnter (to, from, next) {
      if (store.getters.isAuthenticated && store.getters.requirePin) {
        next()
      } else {
        next({ name: 'Login' })
      }
    },
    component: () => import(/* webpackChunkName: "pinEnter" */ '../views/PinEnter.vue')
  },
  {
    path: '/deeplink/:keyword',
    name: 'Deeplink',
    beforeEnter (to, from, next) {
      if (store.getters.isAuthenticated) {
        next()
      } else {
        next({ name: 'Login' })
      }
    },
    component: () => import(/* webpackChunkName: "deeplink" */ '../views/Deeplink.vue')
  },
  {
    path: '/reset-pin-init/:appId/:lang?',
    name: 'ResetPinInit',
    component: () => import(/* webpackChunkName: "resetPinInit" */ '../views/ResetPinInit.vue')
  },
  {
    path: '/reset-pin/:tempToken/:lang?',
    name: 'ResetPin',
    component: () => import(/* webpackChunkName: "resetPin" */ '../views/ResetPin.vue')
  },
  {
    path: '/faq/:id?',
    name: 'FaqView',
    component: () => import(/* webpackChunkName: "faqView" */ '../views/FaqView.vue')
  },
  {
    path: '/error',
    name: 'Error',
    beforeEnter (to, from, next) {
      if (store.state.errorOccurred) {
        next()
      } else {
        next({ name: 'Home' })
      }
    },
    component: () => import(/* webpackChunkName: "error" */ '../views/Error.vue')
  }
]

const router = new VueRouter({
  routes
})

export default router
